import { type ClassName, twx } from '@ctw/shared/utils/tailwind';

export interface ToggleProps {
  id?: string;
  testId?: string;
  className?: ClassName;
  checked: boolean;
  disabled?: boolean;
  label: string;
  onChange: (checked: boolean) => void;
}

export const Toggle = ({
  id,
  testId,
  className,
  checked,
  disabled = false,
  label,
  onChange,
}: ToggleProps) => (
  <button
    id={id}
    data-testid={testId}
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    className={twx(
      className,
      'relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-0 transition-colors',
      {
        'bg-primary-main': checked,
        'bg-divider-main': !checked,
        'cursor-not-allowed opacity-50': disabled,
      },
    )}
  >
    <span
      className={twx(
        'inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform',
        {
          // Track is w-11 (44px) with a 20px knob; a 2px inset on both ends matches the 2px the
          // knob already sits from the top/bottom (h-5 knob in an h-6 track), so the gap around the
          // knob is even. Travel = 44 - 20 - 2 - 2 = 20px.
          'translate-x-[22px]': checked,
          'translate-x-0.5': !checked,
        },
      )}
    />
  </button>
);
